module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/inclusive_computing_teaching_primary-613463363e420d70ce6e8c19d71822e6.jpeg";